import React from "react";
import classNames from "classnames";
import find from "lodash/find";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { getSizeText } from "web/script/utils/size";
import { Size } from "web/types/examples/size";
import styles from "./size-select.css";

export interface SizeSelectProps {
    availableSizes: number;
    onChange: (event) => void;
    onFocus: () => void;
    selectedSize: Size | null;
    sizePickerError: boolean;
    sizes: Size[];
}

export default function SizeSelect({
    availableSizes,
    onChange,
    onFocus,
    selectedSize,
    sizePickerError,
    sizes,
}: SizeSelectProps): React.ReactElement {
    let selectedSizeText: string | undefined;
    if (selectedSize) {
        selectedSizeText = getSizeText(selectedSize);
    } else {
        selectedSizeText = "Select a size";
    }

    function handleOnChange(event): void {
        const selectedSize = find(sizes, (size) => size.raw_size === event.target.value) as Size; // selectedSize has to come from sizes
        onChange(selectedSize);
    }

    return (
        <>
            <div
                className={classNames(styles.selectWrapper, {
                    [styles.selectWrapperError]: sizePickerError,
                })}
            >
                <div className={styles.sizeSelectLabel}>{selectedSizeText}</div>
                <SVGIcon name="chevron-thin" className={styles.chevronIcon} />
                <select
                    name="buyOption"
                    className={styles.selectDropdown}
                    aria-required="true"
                    defaultValue={availableSizes > 1 ? "" : sizes[0].retailer_size.display_size}
                    onChange={handleOnChange}
                    onFocus={onFocus}
                >
                    {availableSizes > 1 && (
                        <option value="" disabled>
                            {"Select a size"}
                            {/* todo I18N-291 */}
                        </option>
                    )}
                    {sizes.map((size: Size) => {
                        const value = size.raw_size;

                        return (
                            <option
                                key={value}
                                value={value}
                                data-human-size={size.human_size}
                                data-raw-size={size.raw_size}
                            >
                                {getSizeText(size)}
                            </option>
                        );
                    })}
                </select>
            </div>
            {sizePickerError && (
                <div className="form-item-error">
                    <div>{"Please select a size"}</div>
                </div>
            )}
        </>
    );
}
